function LoadingCircle() {
  return (
    <div className="loading-circle-wrapper">
      <div className="loading-circle"/> 
    </div>
  );
}

export default LoadingCircle;